import React from "react";
import { motion } from "framer-motion";
import { MaskLines, FadeUp } from "@/components/Motion";

export const PageHeader = ({ eyebrow, title, lead }) => (
  <section className="relative bg-navy text-ivory pt-40 lg:pt-52 pb-20 lg:pb-28 overflow-hidden grain" data-testid="page-header">
    <div className="absolute inset-0 opacity-10">
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full border border-gold" />
      <div className="absolute -top-20 -right-20 w-[400px] h-[400px] rounded-full border border-gold" />
    </div>
    <div className="relative max-w-[1500px] mx-auto px-6 lg:px-12">
      <FadeUp>
        <span className="text-[12px] uppercase tracking-[0.3em] text-gold font-semibold">{eyebrow}</span>
      </FadeUp>
      <h1 className="mt-8 font-serif text-5xl lg:text-8xl leading-[0.98] max-w-4xl font-semibold">
        <MaskLines lines={Array.isArray(title) ? title : [title]} delay={0.15} />
      </h1>
      {lead && (
        <FadeUp delay={0.5}>
          <p className="mt-10 text-ivory/70 text-lg max-w-2xl leading-relaxed">{lead}</p>
        </FadeUp>
      )}
    </div>
  </section>
);
